export default "__VITE_ASSET__43114eb6__"